import React from "react";
import { useRouter } from "next/router";
import ButtonOutlined from "../../Buttons/ButtonOutlined";
import Modal, { IModalProps } from "../Modal";
import styled from "styled-components";
import { getParagraph14RegularTypography } from "../../../Typography";
import { useTranslation, Trans } from "react-i18next";
import Button from "../../Buttons/Button";
import { getVerticalGap } from "../../../styles";

const Content = styled.div`
  padding: 32px 0;
`;

const Info = styled.p`
  color: ${(props) => props.theme.primaryColor};
  ${getParagraph14RegularTypography};
`;

const Actions = styled.div`
  ${getVerticalGap("8px")};
`;

interface Props extends IModalProps {
  connectWallet: () => void;
  isLoading: boolean;
}

const ConnectWalletModal = ({ isOpen, connectWallet, isLoading }: Props) => {
  const { t } = useTranslation();
  const { back } = useRouter();

  return (
    <Modal isOpen={isOpen} title={t("select-receive-wallet-title")}>
      <Content>
        <Info>
          <Trans
            i18nKey="select-receive-wallet-info"
            components={{ bold: <strong /> }}
          />
        </Info>
      </Content>
      <Actions>
        <ButtonOutlined
          onClick={() => back()}
          text={t("select-receive-wallet-cancel")}
          isLoading={isLoading}
          fullWidth
        />
        <Button
          text="Connect"
          onClick={connectWallet}
          fullWidth
          isLoading={isLoading}
        />
      </Actions>
    </Modal>
  );
};

export default ConnectWalletModal;
